export default {
  data: () => {
    return {
      calculations: [
        {
          name: "Alternative Analysis",
          key: "ALTERNATIVE_ANALYSIS",
          shortName: "AA",
          type: 1,
          wikiUrl: "/wiki/dfb8159d4bfb44a9b469f064fc66a725",
        },
        {
          name: "Production Cost",
          key: "PRODUCTION_COST",
          shortName: "PC",
          type: 2,
          wikiUrl: "/wiki/52199af57c51476fbdc2aa5cc524cc7d",
        },
        {
          name: "Nodal Production Cost",
          key: "NODAL_PRODUCTION_COST",
          shortName: "NPC",
          type: 10,
        },
        {
          name: "Stacked Services Emulator",
          key: "STACKED_SERVICES_EMULATOR",
          shortName: "SSE",
          type: 7,
          wikiUrl: "/wiki/fe88f5201f304925b7ce848ac94fd808",
        },
        {
          name: "Effective Load Carrying Capability",
          key: "ELCC",
          shortName: "ELCC",
          type: 6,
        },
        {
          name: "Power Flow",
          key: "POWER_FLOW",
          shortName: "PF",
          type: 8,
        },
        {
          name: "Short Circuit",
          key: "SHORT_CIRCUIT",
          shortName: "SC",
          type: 9,
        },
        {
          name: "Transient Stability",
          key: "TRANSIENT_STABILITY",
          shortName: "TS",
          type: 12,
        },
        {
          name: "Load Forecast",
          key: "LOAD_FORECAST",
          shortName: "LF",
          type: 13,
        },
      ],
    };
  },
};
